import request from '../util/request'

export function getUserList () {
  return request('/api/users');
}

export function getUserDetail (userId) {
  return request('/api/users/' + userId);
}
